export interface TimelineEventDependency {
    dependencyEventId?: string;
    slowTempoOffsetDays: number;
    mediumTempoOffsetDays: number;
    fastTempoOffsetDays: number;
    currentTempoOffsetDays: number;
}

export const blankTimelineEventDependency = (): TimelineEventDependency => {
    return {
        dependencyEventId: '',
        slowTempoOffsetDays: 0,
        mediumTempoOffsetDays: 0,
        fastTempoOffsetDays: 0,
        currentTempoOffsetDays: 0,
    };
};

export const initTimelineEventDependency = (
    dependencyEventId: string,
    offsetDays: number
): TimelineEventDependency => {
    return {
        dependencyEventId: dependencyEventId,
        slowTempoOffsetDays: offsetDays,
        mediumTempoOffsetDays: offsetDays,
        fastTempoOffsetDays: offsetDays,
        currentTempoOffsetDays: offsetDays,
    };
};
